import AnimatedLineContent from '../components/animated-line-content'
import Grid from '../components/grid'
import Button from '../components/ui/button'
import Container from '../components/ui/container'
import Text from '../components/ui/text'
import { Asset } from '../v2/components/Asset'
import { CMSLink } from '../v2/components/CMSLink'
import { cn } from '@telesoft/lib/web/cn'
import { Page, Asset as AssetT } from '@telesoft/types/payload-types'
import React, { ReactElement } from 'react'
import { VscChevronRight } from 'react-icons/vsc'
import { useInView } from 'react-intersection-observer'

export type ProductHighlightBlockProps = Extract<
  Page['blocks'][0],
  { blockType: 'product-highlight' }
>

export default function ProductHighlight(block: ProductHighlightBlockProps): ReactElement {
  const { title, description, image, link, options } = block

  // TODO: implement this in a new way
  // function handleDownload(resourceId: string, walled: boolean) {
  //   if (walled) {
  //     setModalView('DOWNLOAD_VIEW')
  //     setModalData({ resourceId: resourceId })
  //     return openModal()
  //   }
  // }

  const {
    pulse,
    theme = 'dark',
    elementId,
    imageClassName = 'object-cover object-center opacity-25',
    className = theme === 'dark' ? 'bg-black' : 'bg-accent-1',
    overlayClassName = 'bg-gradient-to-t from-telesoft to-transparent mix-blend-overlay',
  } = options

  const { ref, inView } = useInView({
    threshold: 0.4,
  })

  return (
    <Container>
      <Grid
        id={elementId}
        className={`relative lg:min-h-[500px] place-content-center ${className} p-8 md:p-12 lg:p-20`}
      >
        <div
          ref={ref}
          className="z-20 col-span-full lg:col-span-7  flex relative justify-center items-start"
        >
          <Text
            variant="subHeading"
            className={`${
              theme === 'dark' ? 'text-white' : 'text-black'
            } text-left max-w-md leading-relaxed"`}
          >
            {title}
          </Text>
        </div>
        <div className="z-20 col-span-full lg:col-span-5 flex relative justify-start items-start">
          <div className="flex flex-col justify-start items-start max-w-md">
            {inView && <AnimatedLineContent variant={theme === 'dark' ? 'light' : 'dark'} />}
            <Text className={`pt-6 ${theme === 'dark' ? 'text-white' : 'text-black'}`}>
              {description}
            </Text>
            <hr className="my-4" />
            <CMSLink {...link} inverted={theme === "dark" ? true : false} />
          </div>
        </div>

        <div className={`z-10 absolute inset-0 ${overlayClassName}`} />

        <div className="absolute inset-0 z-0">
          <Asset
            resource={image as AssetT}
            imgClassName={cn(`${imageClassName}`, {
              'object-contain animate-pulse': pulse,
            })}
            fill
          />
        </div>
      </Grid>
    </Container>
  )
}
